// returned by step methods to indicate the outcome of the operation.  Used to control assignment execution flow
export const StepResult = {
    Failure: -1, // returned when the step method has reached the end of the item's content (termination)
    Stepped: 0, // returned when the step method successfully increments the returned content (container progresses to next item of content)
    SteppedWithMore: 1, // returned when the step method successfully increments, but the item has more content to offer (i.e. for subjects, sections, etc)
};